import Instance from "../../../../Axios";

// New Actions for the app

const GetWorkPermitDefaultSendEmails = () => async (dispatch) => {
  await Instance()
    .get(`/construcoes/workpermits/defaultSendEmails`)
    .then(({ data }) => {
      // console.log(data);
      dispatch({ type: "GET_WORK_PERMIT_DEFAULT_SEND_EMAILS", payload: data.yData });
      // setObraSelecionada(data.yData[0]);
    })
    .catch((err) => {
      console.log(err);
    });
};

export default GetWorkPermitDefaultSendEmails;